import { z } from 'zod';

export const FullURL = z.string().url();

export type FullURL = z.infer<typeof FullURL>;
